import qs from 'qs'
export default{
	install(Vue,options)
	{
		//全局变量
		//关闭生产模式下给出的提示
		//Vue.config.productionTip = false
		//移动端系统判断
		Vue.prototype.isMobile = {
			Android : function() {
				return navigator.userAgent.match(/Android/i) ? true : false;
			},
			BlackBerry : function() {
				return navigator.userAgent.match(/BlackBerry/i) ? true : false;
			},
			iOS : function() {
				return navigator.userAgent.match(/iPhone|iPad|iPod/i) ? true : false;
			},
			Windows : function() {
				return navigator.userAgent.match(/IEMobile/i) ? true : false;
			},
			other : function() {
				return (this.Android() || this.BlackBerry() || this.iOS() || this.Windows());
			}
		};
		Vue.prototype.langArr = ['','gb','big','en','kr','th','vn','jp','id','fr','es'];
		Vue.prototype.source = (function(lan){
			var _source = {};

			if(this.isMobile.other()){
				_source = {'en': 72, 'kr': 73, 'th': 74, 'vn': 75, 'id': 77};
			}else{
				_source = {'en': 64, 'kr': 65, 'th': 66, 'vn': 67, 'id': 69};
			}
			return _source[lan];
		});
		Vue.prototype.langIndex = (function(){
			if(location.hostname.indexOf('7msport') > -1)
				return 3;
			else if(location.hostname.indexOf('7mkr') > -1)
				return 4;
			else if(location.hostname.indexOf('7mth') > -1)
				return 5;
			else if(location.hostname.indexOf('7mvn') > -1)
				return 6;
			else if(location.hostname.indexOf('-id.7msport') > -1)
				return 3;
			else
				return 1;		
		})();
		Vue.prototype.langName = (function(){
			if(location.hostname.indexOf('7msport') > -1)
				return 'en';
			else if(location.hostname.indexOf('7mkr') > -1)
				return 'kr';
			else if(location.hostname.indexOf('7mth') > -1)
				return 'th';
			else if(location.hostname.indexOf('7mvn') > -1)
				return 'vn';
			else if(location.hostname.indexOf('-id.7msport') > -1)
				return 'en';
			else
				return 'en';
		})();

        Vue.prototype.noticeNum = 0;//通知数量

		Vue.prototype.timezone = (function(){
			var obj = {
				'gb':'+0800',
				'en':'+0700',
				'kr':'+0900',
				'th':'+0700',
				'vn':'+0700'
			}

			if(location.hostname.indexOf('7msport') > -1)
				return obj.en;
			else if(location.hostname.indexOf('7mkr') > -1)
				return obj.kr;
			else if(location.hostname.indexOf('7mth') > -1)
				return obj.th;
			else if(location.hostname.indexOf('7mvn') > -1)
				return obj.vn;
			else if(location.hostname.indexOf('-id.7msport') > -1)
				return obj.en;
			else
				return obj.gb;
		})();

		Vue.prototype.noticeNum = 0;//通知数量

		Vue.prototype.aniCoinNum = '';
		Vue.prototype.aniCoinSH = false;

		Vue.prototype.aniCoinShow = function(num){
			this.aniCoinNum = num;
			this.aniCoinSH = true;
			this.$forceUpdate();
			var that = this;
			// console.log(this.aniCoinNum);
			// console.log(this.aniCoinSH);
			setTimeout(function(){
				that.aniCoinNum = '';
				that.aniCoinSH = false;
				that.$forceUpdate();
				// console.log(that.aniCoinNum);
				// console.log(that.aniCoinSH);
			},2000);
		}

		///////////////////////////////////////////////////////////////
		//全局函数
		//获取接口头
		Vue.prototype.getHost = function(){
			var langApiName = "";
			
        	if(location.hostname.indexOf('7msport') > -1)
				langApiName = '7msport';
			else if(location.hostname.indexOf('7mkr') > -1)
				langApiName = '7mkr';
			else if(location.hostname.indexOf('7mth') > -1)
				langApiName = '7mth';
			else if(location.hostname.indexOf('7mvn') > -1)
				langApiName = '7mvn';
			else if(location.hostname.indexOf('-id.7msport') > -1)
				langApiName = '7msport';
			else
				langApiName = '7msport';
			

			var host = location.host;
			if(host.indexOf('192.168.50.112') > -1 || host.indexOf('localhost') > -1) {
				return '';
			}else if(host.indexOf('127.0.0.1') > -1){
				return '//api-dev.' + langApiName + '.com/oversea-guess/api';
			}
			else{
				if(host.indexOf('-dev') > -1)
					return '//api-dev.' + langApiName + '.com/oversea-guess/api';
				else if(host.indexOf('-test') > -1)
					return '//api-test.' + langApiName + '.com/oversea-guess/api';
				else
					return '//api.' + langApiName + '.com/oversea-guess/api';
			}
		};

		Vue.prototype.getLocal = function(){
			var langApiName = "";

			if(location.hostname.indexOf('7msport') > -1)
				langApiName = '7msport';
			else if(location.hostname.indexOf('7mkr') > -1)
				langApiName = '7mkr';
			else if(location.hostname.indexOf('7mth') > -1)
				langApiName = '7mth';
			else if(location.hostname.indexOf('7mvn') > -1)
				langApiName = '7mvn';
			else if(location.hostname.indexOf('-id.7msport') > -1)
				langApiName = '7msport';
			else
				langApiName = '7msport';

			return langApiName;
		};

        Vue.prototype.getHost2 = function(){

            var host = location.host;

            if(host.indexOf('192.168.50.112') > -1 || host.indexOf('localhost') > -1)
                return '';
            else if(host.indexOf('-dev') > -1)
				return '//api-dev.'+ this.getLocal() +'.com/accounts';
			else if(host.indexOf('-test') > -1)
				return '//api-test.'+ this.getLocal() +'.com/accounts';
			else
				return '//api.'+ this.getLocal() +'.com/accounts';
        };

        Vue.prototype.getHostName = function(){
            if(location.href.indexOf('test') > -1){
                return '-test';
            }
            if(location.href.indexOf('dev') > -1 || location.href.indexOf('localhost') > -1 || location.href.indexOf('127.0.0.1') > -1){
                return '-dev';
            }
            return '';
		};

		//保存cookie
		Vue.prototype.setCookie = function(name,value) 
		{ 
		    var exdays = 30;
		    var d = new Date();
		    d.setTime(d.getTime()+(exdays*24*60*60*1000));
		    var expires = "expires="+d.toGMTString();
		    document.cookie = name + "=" + value + "; " + expires + ";path=/";
		} 

		//获取cookie
		Vue.prototype.getCookie = function(name) 
		{ 
		    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
		 
		    if(arr=document.cookie.match(reg))
		 
		        return unescape(arr[2]); 
		    else 
		        return null; 
		} 

		//删除cookie
		Vue.prototype.delCookie = function(name) 
		{ 
		    var exp = new Date(); 
		    exp.setTime(exp.getTime() - 1); 

		    var cval=this.getCookie(name); 
		    if(cval!=null) 
		        document.cookie= name + "="+cval+";expires="+exp.toGMTString() + ";path=/"; 
		}

		//获取日期对象,获取当天传空，获取某天传2020-12-12格式
		Vue.prototype.getDateObj = function(day){
			function getDateByDateStr(dateStr, timeZone, format){
		        var date_sl = dateStr.split(",");
		        var dtm = '';
		        if(date_sl.length<6) date_sl[5]='00';
		        if(timeZone=="+0800"){
		            dtm =  new Date(Number(date_sl[0]), Number(date_sl[1]) - 1, Number(date_sl[2]), Number(date_sl[3]), Number(date_sl[4]), Number(date_sl[5]), 0);
		        }
		        else{
		            var TZ_Hour = parseFloat(timeZone.substring(0, 3));
		            var TZ_Minute = parseFloat(timeZone.substring(3, 5));
		            var tz_mintue_diff2 = TZ_Minute;
		            var tz_hour_diff2;
		            if (TZ_Hour < 0){
		                tz_hour_diff2 = -( 0 - (8 - TZ_Hour));
		                tz_mintue_diff2 = -(0 - tz_mintue_diff2);
		            }else{
		                tz_hour_diff2 = -(TZ_Hour - 8);
		            }
		            dtm =   new Date(Number(date_sl[0]), Number(date_sl[1]) - 1, Number(date_sl[2]), Number(date_sl[3])+tz_hour_diff2, Number(date_sl[4])+tz_mintue_diff2, Number(date_sl[5]), 0);
		        }
		        var dateFormat = format;
		        dateFormat = dateFormat.replace('YYYY',dtm.getFullYear());
		        dateFormat = dateFormat.replace('YY',String(dtm.getFullYear()).substring(2));
		        dateFormat = dateFormat.replace('MM',dtm.getMonth()<9?("0" +(dtm.getMonth()+1)):(dtm.getMonth()+1));
		        dateFormat = dateFormat.replace('dd',dtm.getDate()<10?("0" +dtm.getDate()):dtm.getDate());
		        dateFormat = dateFormat.replace('HH',dtm.getHours()<10?("0" +dtm.getHours()):dtm.getHours());
		        dateFormat = dateFormat.replace('mm',dtm.getMinutes()<10?("0" +dtm.getMinutes()):dtm.getMinutes());
		        dateFormat = dateFormat.replace('ss',dtm.getSeconds()<10?("0" +dtm.getSeconds()):dtm.getSeconds());
		        return dateFormat;
		    }

			var date = day == '' ? new Date() : new Date(day.replace(/-/g,'/'));
			var obj = {};
			obj['YYYY'] = date.getFullYear();
			var m = parseInt(date.getMonth()) + 1;
			obj['MM'] = m < 10 ? ('0' + m) : m; 
			var d = date.getDate();
			obj['DD'] = d < 10 ? ('0' + d) : d;
			
		    var dateStr1 = obj.YYYY + '-' + obj.MM + '-' + obj.DD + ' 00:00:00';
		    var dateStr2 = obj.YYYY + '-' + obj.MM + '-' + obj.DD + ' 23:59:59';
		    
		    var timezone = Vue.prototype.timezone;
		    //转时区后得到新的'YYYY/MM/dd HH:mm:ss'格式时间
		    var re1 = getDateByDateStr(dateStr1.replace(/\D/g, ','),timezone,'YYYY/MM/dd HH:mm:ss');
		    var re2 = getDateByDateStr(dateStr2.replace(/\D/g, ','),timezone,'YYYY/MM/dd HH:mm:ss');
		    
			var date_start = new Date(re1).getTime() / 1000;
			var date_end = new Date(re2).getTime() / 1000;
			obj['start'] = date_start;
			obj['end'] = date_end;
			return obj;
		}

		//ballType=2&lan=1&plat=2&token=379b61fbd58c1160226ca0e4342fe31c4ef8795a
		Vue.prototype.setLoginInfo = function(callback){
			//localStorage.removeItem('accessToken');
			const params = this.$route.query;
			//如果地址栏带accesstoken
			if(params.hasOwnProperty('token')){
				if(params.hasOwnProperty('ballType'))
					localStorage.setItem('ballType',params.ballType);
				else
					localStorage.setItem('ballType',1);

				if(params.hasOwnProperty('lan')){
					this.langName = this.langArr[params.lan];
					localStorage.setItem('langIndex',params.lan);
					localStorage.setItem('lang',this.langArr[params.lan]);
				}

				if(params.hasOwnProperty('plat'))
					localStorage.setItem('plat',params.plat);
				else
					localStorage.setItem('plat',params.isapp);

				//获取本地accesstoken
				const local_accessToken = localStorage.getItem('accessToken');
				//如果本地accesstoken不为空
				if(local_accessToken != null ){
					//本地accesstoken不等于地址栏accesstoken，覆盖本地aceesstoken
					if(local_accessToken != params.token){
						localStorage.setItem('accessToken',params.token);
						this.getToken(callback);
					}
					else{
						callback();
					}
				}
				//本地accesstoken为空，把地址栏的accesstoken保存到本地
				else{
					localStorage.setItem('accessToken',params.token);
					this.getToken(callback);
				}
				
			}
			else{
				callback();
			}
		}

		//日期处理加强版，含时区
		Vue.prototype.dateStrPower = function(str,type){
		    //转换时区时间————东八区转其它时区
		    function getDateByDateStr(dateStr, timeZone, format){
		        var date_sl = dateStr.split(",");
		        var dtm = '';
		        if(date_sl.length<6) date_sl[5]='00';
		        if(timeZone=="+0800"){
		            dtm =  new Date(Number(date_sl[0]), Number(date_sl[1]) - 1, Number(date_sl[2]), Number(date_sl[3]), Number(date_sl[4]), Number(date_sl[5]), 0);
		        }
		        else{
		            var TZ_Hour = parseFloat(timeZone.substring(0, 3));
		            var TZ_Minute = parseFloat(timeZone.substring(3, 5));
		            var tz_mintue_diff2 = TZ_Minute;
		            var tz_hour_diff2;
		            if (TZ_Hour < 0){
		                tz_hour_diff2 = 0 - (8 - TZ_Hour);
		                tz_mintue_diff2 = 0 - tz_mintue_diff2;
		            }else{
		                tz_hour_diff2 = TZ_Hour - 8;
		            }
		            dtm =   new Date(Number(date_sl[0]), Number(date_sl[1]) - 1, Number(date_sl[2]), Number(date_sl[3])+tz_hour_diff2, Number(date_sl[4])+tz_mintue_diff2, Number(date_sl[5]), 0);
		        }
		        var dateFormat = format;
		        dateFormat = dateFormat.replace('YYYY',dtm.getFullYear());
		        dateFormat = dateFormat.replace('YY',String(dtm.getFullYear()).substring(2));
		        dateFormat = dateFormat.replace('MM',dtm.getMonth()<9?("0" +(dtm.getMonth()+1)):(dtm.getMonth()+1));
		        dateFormat = dateFormat.replace('dd',dtm.getDate()<10?("0" +dtm.getDate()):dtm.getDate());
		        dateFormat = dateFormat.replace('HH',dtm.getHours()<10?("0" +dtm.getHours()):dtm.getHours());
		        dateFormat = dateFormat.replace('mm',dtm.getMinutes()<10?("0" +dtm.getMinutes()):dtm.getMinutes());
		        dateFormat = dateFormat.replace('ss',dtm.getSeconds()<10?("0" +dtm.getSeconds()):dtm.getSeconds());
		        return dateFormat;
		    }

		    var lang = Vue.prototype.langName;
		    var timezone = Vue.prototype.timezone;

		    var date = new Date(str*1000);
			var YYYY = date.getFullYear();
			var MM = date.getMonth() + 1;
			MM = MM < 10 ? '0' + MM : MM;
			var dd = date.getDate();
			dd = dd < 10 ? '0' + dd : dd;
			var HH = date.getHours();
			HH = HH < 10 ? '0' + HH : HH;
			var mm = date.getMinutes();
			mm = mm < 10 ? '0' + mm : mm;
			var ss = date.getSeconds();
			ss = ss < 10 ? '0' + ss : ss;

			date = YYYY + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss;

		    //日期格式
		    var formal = '';
		    if(typeof(type) == 'undefined'){
		        if(lang == 'gb' || lang == 'big')
		            formal = 'YYYY年MM月dd日 HH:mm:ss';
		        else if(lang == 'en')
		            formal = 'dd/MM/YYYY HH:mm:ss';
		        else if(lang == 'kr')
		            formal = 'YYYY.MM.dd HH:mm:ss';
		        else if(lang == 'th')
		            formal = 'dd-MM-YYYY HH:mm:ss';
		        else if(lang == 'vn')
		            formal = 'dd/MM/YYYY HH:mm:ss';
		        else if(lang == 'jp')
		            formal = 'YYYY/MM/dd HH:mm:ss';
		        else if(lang == 'fr')
		            formal = 'dd.MM.YYYY HH:mm:ss';
		        else if(lang == 'es')
		            formal = 'dd.MM.YYYY HH:mm:ss';
		        else if(lang == 'id')
		            formal = 'dd/MM/YYYY HH:mm:ss';
		    }
		    else if(type == 0){
		        if(lang == 'gb' || lang == 'big')
		            formal = 'YYYY年MM月dd日 HH:mm';
		        else if(lang == 'en')
		            formal = 'dd/MM/YYYY HH:mm';
		        else if(lang == 'kr')
		            formal = 'YYYY.MM.dd HH:mm';
		        else if(lang == 'th')
		            formal = 'dd-MM-YYYY HH:mm';
		        else if(lang == 'vn')
		            formal = 'dd/MM/YYYY HH:mm';
		        else if(lang == 'jp')
		            formal = 'YYYY/MM/dd HH:mm';
		        else if(lang == 'fr')
		            formal = 'dd.MM.YYYY HH:mm';
		        else if(lang == 'es')
		            formal = 'dd.MM.YYYY HH:mm';
		        else if(lang == 'id')
		            formal = 'dd/MM/YYYY HH:mm';
		    }
		    else if(type == 1){
		        if(lang == 'gb' || lang == 'big')
		            formal = 'YYYY年MM月dd日(w)';
		        else if(lang == 'en')
		            formal = 'dd/MM/YYYY w';
		        else if(lang == 'kr')
		            formal = 'YYYY.MM.dd w';
		        else if(lang == 'th')
		            formal = 'dd-MM-YYYY w';
		        else if(lang == 'vn')
		            formal = 'w dd/MM/YYYY';
		        else if(lang == 'jp')
		            formal = 'YYYY/MM/dd(w)';
		        else if(lang == 'fr')
		            formal = 'w dd.MM.YYYY';
		        else if(lang == 'es')
		            formal = 'w dd.MM.YYYY';
		        else if(lang == 'id')
		            formal = 'dd/MM/YYYY (w)';
		    }
		    else if(type == 2){
		        if(lang == 'gb' || lang == 'big')
		            formal = 'YYYY.MM.dd';
		        else if(lang == 'en')
		            formal = 'dd/MM/YYYY';
		        else if(lang == 'kr')
		            formal = 'YYYY.MM.dd';
		        else if(lang == 'th')
		            formal = 'dd-MM-YYYY';
		        else if(lang == 'vn')
		            formal = 'dd/MM/YYYY';
		        else if(lang == 'jp')
		            formal = 'YYYY/MM/dd';
		        else if(lang == 'fr')
		            formal = 'dd.MM.YYYY';
		        else if(lang == 'es')
		            formal = 'dd.MM.YYYY';
		        else if(lang == 'id')
		            formal = 'dd/MM/YYYY';
		    }
		    else if(type == 3){
		        if(lang == 'gb' || lang == 'big')
		            formal = 'MM-dd (w) HH:mm';
		        else if(lang == 'en')
		            formal = 'dd/MM w HH:mm';
		        else if(lang == 'kr')
		            formal = 'MM.dd w HH:mm';
		        else if(lang == 'th')
		            formal = 'dd-MM w HH:mm';
		        else if(lang == 'vn')
		            formal = 'w dd/MM HH:mm';
		        else if(lang == 'jp')
		            formal = 'MM/dd(w)HH:mm';
		        else if(lang == 'fr')
		            formal = 'w dd.MM HH:mm';
		        else if(lang == 'es')
		            formal = 'w dd.MM HH:mm';
		        else if(lang == 'id')
		            formal = 'w dd/MM HH:mm';
		    }
		    else if(type == 4){
		        if(lang == 'gb' || lang == 'big')
		            formal = 'MM-dd HH:mm';
		        else if(lang == 'en')
		            formal = 'dd/MM HH:mm';
		        else if(lang == 'kr')
		            formal = 'MM.dd HH:mm';
		        else if(lang == 'th')
		            formal = 'dd-MM HH:mm';
		        else if(lang == 'vn')
		            formal = 'dd/MM HH:mm';
		        else if(lang == 'jp')
		            formal = 'MM/dd HH:mm';
		        else if(lang == 'fr')
		            formal = 'dd.MM HH:mm';
		        else if(lang == 'es')
		            formal = 'dd.MM HH:mm';
		        else if(lang == 'id')
		            formal = 'dd/MM HH:mm';
		    }
		    else if(type == 5){
		        if(lang == 'gb' || lang == 'big')
		            formal = 'YYYY-MM-dd HH:mm';
		        else if(lang == 'en')
		            formal = 'dd/MM/YYYY HH:mm';
		        else if(lang == 'kr')
		            formal = 'YYYY.MM.dd HH:mm';
		        else if(lang == 'th')
		            formal = 'dd-MM-YYYY HH:mm';
		        else if(lang == 'vn')
		            formal = 'dd/MM/YYYY HH:mm';
		        else if(lang == 'jp')
		            formal = 'YYYY/MM/dd HH:mm';
		        else if(lang == 'fr')
		            formal = 'dd.MM.YYYY HH:mm';
		        else if(lang == 'es')
		            formal = 'dd.MM.YYYY HH:mm';
		        else if(lang == 'id')
		            formal = 'dd/MM/YYYY HH:mm';
		    }
		    else if(type == 6){
		        if(lang == 'gb' || lang == 'big')
		            formal = 'YY-MM-dd';
		        else if(lang == 'en')
		            formal = 'dd/MM/YY';
		        else if(lang == 'kr')
		            formal = 'YYYY.MM.dd';
		        else if(lang == 'th')
		            formal = 'dd-MM-YY';
		        else if(lang == 'vn')
		            formal = 'dd/MM/YY';
		        else if(lang == 'jp')
		            formal = 'YY/MM/dd';
		        else if(lang == 'fr')
		            formal = 'dd.MM.YY';
		        else if(lang == 'es')
		            formal = 'dd.MM.YY';
		        else if(lang == 'id')
		            formal = 'dd/MM/YY';
		    }
		    return getDateByDateStr(date.replace(/\D/g, ','),timezone,formal);
		}

		//日期处理，返回月-日 时:分
		Vue.prototype.dateStr = function(str){
			const date = new Date(str*1000);
			const YYYY = date.getFullYear();
			let MM = date.getMonth() + 1;
			MM = MM < 10 ? '0' + MM : MM;
			let dd = date.getDate();
			dd = dd < 10 ? '0' + dd : dd;
			let HH = date.getHours();
			HH = HH < 10 ? '0' + HH : HH;
			let mm = date.getMinutes();
			mm = mm < 10 ? '0' + mm : mm;
			let ss = date.getSeconds();
			ss = ss < 10 ? '0' + ss : ss;

			let formal;
			const langName = this.langName;
			if(langName == 'gb' || langName == 'big')
                formal = 'MM-dd HH:mm';
            else if(langName == 'en')
                formal = 'dd/MM HH:mm';
            else if(langName == 'kr')
                formal = 'MM.dd HH:mm';
            else if(langName == 'th')
                formal = 'dd-MM HH:mm';
            else if(langName == 'vn')
                formal = 'dd/MM HH:mm';
            else if(langName == 'jp')
                formal = 'MM/dd HH:mm';
            else if(langName == 'fr')
                formal = 'dd.MM HH:mm';
            else if(langName == 'es')
                formal = 'dd.MM HH:mm';
            else if(langName == 'id')
                formal = 'dd/MM HH:mm';

			return formal.replace('MM',MM)
						 .replace('dd',dd)
						 .replace('HH',HH)
						 .replace('mm',mm);
		}

		//日期处理,返回年-月-日 时:分:秒
		Vue.prototype.dateStr2 = function(str){
			const date = new Date(str*1000);
			const YYYY = date.getFullYear();
			let MM = date.getMonth() + 1;
			MM = MM < 10 ? '0' + MM : MM;
			let dd = date.getDate();
			dd = dd < 10 ? '0' + dd : dd;
			let HH = date.getHours();
			HH = HH < 10 ? '0' + HH : HH;
			let mm = date.getMinutes();
			mm = mm < 10 ? '0' + mm : mm;
			let ss = date.getSeconds();
			ss = ss < 10 ? '0' + ss : ss;

			let formal;
			const langName = this.langName;
			if(langName == 'gb' || langName == 'big')
                formal = 'YYYY-MM-dd HH:mm:ss';
            else if(langName == 'en')
                formal = 'dd/MM/YYYY HH:mm:ss';
            else if(langName == 'kr')
                formal = 'YYYY.MM.dd HH:mm:ss';
            else if(langName == 'th')
                formal = 'dd-MM-YYYY HH:mm:ss';
            else if(langName == 'vn')
                formal = 'dd/MM/YYYY HH:mm:ss';
            else if(langName == 'jp')
                formal = 'YYYY/MM/dd HH:mm:ss';
            else if(langName == 'fr')
                formal = 'dd.MM.YYYY HH:mm:ss';
            else if(langName == 'es')
                formal = 'dd.MM.YYYY HH:mm:ss';
            else if(langName == 'id')
                formal = 'dd/MM/YYYY HH:mm:ss';

			return formal.replace('YYYY',YYYY)
						 .replace('MM',MM)
						 .replace('dd',dd)
						 .replace('HH',HH)
						 .replace('mm',mm)
						 .replace('ss',ss);
		}

		//日期处理,返回月-日 时:分:秒
		Vue.prototype.dateStr3 = function(str){
			const date = new Date(str*1000);
			const YYYY = date.getFullYear();
			let MM = date.getMonth() + 1;
			MM = MM < 10 ? '0' + MM : MM;
			let dd = date.getDate();
			dd = dd < 10 ? '0' + dd : dd;
			let HH = date.getHours();
			HH = HH < 10 ? '0' + HH : HH;
			let mm = date.getMinutes();
			mm = mm < 10 ? '0' + mm : mm;
			let ss = date.getSeconds();
			ss = ss < 10 ? '0' + ss : ss;

			let formal;
			const langName = this.langName;
			if(langName == 'gb' || langName == 'big')
                formal = 'MM-dd HH:mm:ss';
            else if(langName == 'en')
                formal = 'dd/MM HH:mm:ss';
            else if(langName == 'kr')
                formal = 'MM.dd HH:mm:ss';
            else if(langName == 'th')
                formal = 'dd-MM HH:mm:ss';
            else if(langName == 'vn')
                formal = 'dd/MM HH:mm:ss';
            else if(langName == 'jp')
                formal = 'MM/dd HH:mm:ss';
            else if(langName == 'fr')
                formal = 'dd.MM HH:mm:ss';
            else if(langName == 'es')
                formal = 'dd.MM HH:mm:ss';
            else if(langName == 'id')
                formal = 'dd/MM HH:mm:ss';

			return formal.replace('MM',MM)
						 .replace('dd',dd)
						 .replace('HH',HH)
						 .replace('mm',mm)
						 .replace('ss',ss);
		}

		//盘口转换
		Vue.prototype.oddsT = function(odds,type){
			const lang = this.langName;
		    if(lang == 'gb' || lang == 'big'){
		        var RQ_ARR = ["平手", "平/半", "半球", "半/一", "一球", "一/半", "球半", "球半/二", "二球", "二/半", "二半", "二半/三", "三球", "三/半", "三半", "三半/四", "四球", "四/半", "四半", "四半/五", "五球", "五/五半", "五半", "五半/六", "六球", "六/六半", "六半", "六半/七", "七球", "七/七半", "七半", "七半/八", "八球", "八/八半", "八半", "八半/九", "九球", "九/九半", "九半", "九半/十", "十球", "十/十半", "十半", "十半/十一", "十一球", "十一/十一半", "十一半", "十一半/十二球", "十二球", "十二/十二半", "十二半", "十二半/十三球", "十三球", "十三/十三半", "十三半", "十三半/十四球", "十四球", "十四/十四半", "十四半", "十四半/十五球", "十五球", "十五/十五半", "十五半", "十五半/十六球", "十六球", "十六/十六半", "十六半", "十六半/十七球", "十七球", "十七/十七半", "十七半", "十七半/十八球", "十八球", "十八/十八半", "十八半", "十八半/十九球", "十九球", "十九/十九半", "十九半", "十九半/二十球", "二十球"];
		        var shou = '';
		        if(odds < 0){
		            odds = -odds;
		        }
		        else{
		            shou = '受';
		            if(type == 3 || odds == '0.00')
		            	shou = '';
		        }
		        return shou + RQ_ARR[parseInt(Number(odds).toFixed(2) * 4)];
		    }
		    else if(lang == 'vn'){
		        var RQ_ARR = ["0", "1/4", "1/2", "3/4", "1", "1 1/4", "1 1/2", "1 3/4", "2", "2 1/4", "2 1/2", "2 3/4", "3", "3 1/4", "3 1/2", "3 3/4", "4", "4 1/4", "4 1/2", "4 3/4", "5", "5 1/4", "5 1/2", "5 3/4", "6", "6 1/4", "6 1/2", "6 3/4", "7", "7 1/4", "7 1/2", "7 3/4", "8", "8 1/4", "8 1/2", "8 3/4", "9", "9 1/4", "9 1/2", "9 3/4", "10", "10 1/4", "10 1/2", "10 3/4", "11", "11 1/4", "11 1/2", "11 3/4", "12", "12 1/4", "12 1/2", "12 3/4", "13", "13 1/4", "13 1/2", "13 3/4", "14", "14 1/4", "14 1/2", "14 3/4", "15", "15 1/4", "15 1/2", "15 3/4", "16", "16 1/4", "16 1/2", "16 3/4", "17", "17 1/4", "17 1/2", "17 3/4", "18", "18 1/4", "18 1/2", "18 3/4", "19", "19 1/4", "19 1/2", "19 3/4", "20"];
		        var str = '';
		        if(odds < 0){
		            odds = -odds;
		            str = '0:' + RQ_ARR[parseInt(Number(odds).toFixed(2) * 4)];
		        }
		        else{
		            str = RQ_ARR[parseInt(Number(odds).toFixed(2) * 4)] +  ':0';
		        }
		        if(type == 3){
		        	str = str.replace(':0','').replace('0:','');
		        }
		        return str;
		    }
		    else{
		        var RQ_ARR = ["0", "0/0.5", "0.5", "0.5/1", "1", "1/1.5", "1.5", "1.5/2", "2", "2/2.5", "2.5", "2.5/3", "3", "3/3.5", "3.5", "3.5/4", "4", "4/4.5", "4.5", "4.5/5", "5", "5/5.5", "5.5", "5.5/6", "6", "6/6.5", "6.5", "6.5/7", "7", "7/7.5", "7.5", "7.5/8", "8", "8/8.5", "8.5", "8.5/9", "9", "9/9.5", "9.5", "9.5/10", "10", "10/10.5", "10.5", "10.5/11", "11", "11/11.5", "11.5", "11.5/12", "12", "12/12.5", "12.5", "12.5/13", "13", "13/13.5", "13.5", "13.5/14", "14", "14/14.5", "14.5", "14.5/15", "15", "15/15.5", "15.5", "15.5/16", "16", "16/16.5", "16.5", "16.5/17", "17", "17/17.5", "17.5", "17.5/18", "18", "18/18.5", "18.5", "18.5/19", "19", "19/19.5", "19.5", "19.5/20", "20"];
		        var shou = '+';
		        if(odds < 0){
		            odds = -odds;
		            shou = '-';
		        }
		        else{
		        	if(type == 3 || odds == 0)
		        		shou = '';
		        }
		        if(lang == 'th'){
	            	shou = shou == '+' ? '-' : '';
	            }
		        return shou + RQ_ARR[parseInt(Number(odds).toFixed(2) * 4)];
		    }	
		}

		//计算返还M币
		Vue.prototype.calBack = function(type,num,odds){
			if(type == 1){
				return (num  * (odds * 1000) - num * 1000) / 1000;
			}
			else{
				return num * (odds * 1000) / 1000;
			}
		}

		//获取球队logo地址
		Vue.prototype.imgGet = function(id){
  			return '//data.7m.com.cn/team_data/' + id + '/logo_Img/club_logo.jpg';
		}

		//处理图片获取404
		Vue.prototype.imgError = function(e) {
	  		//console.log(e);
	  		var time = e.target.getAttribute('time');
	  		//console.log(time);
	  		if(parseInt(time) == 0){
	  			var src = e.target.src;
		  		src = src.replace('.jpg','.gif');
		  		e.target.src = src;
		  		e.target.setAttribute('time','1');
	  		}
	  		else{
	  			e.target.src = (location.origin.indexOf('localhost:8080') > -1 ? '/' : './' ) + 'static/image/default_logo.gif';
	  		}
	  	}

	  	//自定义alert弹窗
		Vue.prototype.tip = function(str){
			alert(str);
		}

		//千分位金币转换
		Vue.prototype.moneyStr = function(m){
			m = m + '';
			if(m.indexOf('.') != '-1'){
	            var b = m.split('.')[0];
	            var len=b.length;
	            if(len<=3){return b;}
	            var r=len%3;
	            return r>0?b.slice(0,r)+","+b.slice(r,len).match(/\d{3}/g).join(","):b.slice(r,len).match(/\d{3}/g).join(",") + '.' + m.split('.')[1];
	        }else{
	            var b=parseInt(m).toString();
	            var len=b.length;
	            if(len<=3){return b;}
	            var r=len%3;
	            return r>0?b.slice(0,r)+","+b.slice(r,len).match(/\d{3}/g).join(","):b.slice(r,len).match(/\d{3}/g).join(",");
	        }
		};

		/**
         * 字符串替换
         * @param str- 被替换文本, rep- 被替换字符, sub- 替换字符
		 */
		Vue.prototype.stringSub = function(str, rep, sub){
            var reg = new RegExp(rep, 'g');
            var _str = str.replace(reg, sub);

            return _str;
		};

        /**
         * localStorage存储登录数据
         */
        Vue.prototype.infoStorage = function(name, value){
            localStorage.setItem(name, value);
        };

        /**
         * localStorage存储登录数据删除登录数据
         */
        Vue.prototype.delStorage = function(name){
            if(localStorage.getItem(name) != null) {
                localStorage.removeItem(name);
            }
        };

        /**
         * 用户是否登录
         * @param options对象参数
         * @param appId- 应用id, success- 回调
         */
		Vue.prototype.isUserLogin = function(options){
            var defaults = {
                appId: 100002,
                source: null,
                platform: null,//平台(非必填 1 APP 2 webapp 3 PC)
                success: null,
                lan:null,
            };

            defaults = Object.assign(defaults, options);

            var _isLogin = 0;

            this.axios.create({withCredentials: true}).get(this.getHost2() + '/passport/echo').then(
                (response)=>{
                    var re = response.data;
                    _isLogin = re['data']['is_login'];

                    if(re.code == 0){
                        if(re['data']['is_login'] == 1) {//已登录

                            if(defaults.source == null){
                                defaults.source = this.source(this.langName);
                            }
                            if(defaults.platform == null){
                                defaults.platform = 5;
                            }
                            if(defaults.lan == null){
                            	defaults.lan = this.langIndex;
                            }

							let _token = localStorage.getItem('guess_token');
							var _this = this;
							if(_token != null){
								this.getUserInfo({
									success: function(response){
										var re = response.data;
										
										if(re.code == 401){
											_this.getToken({
												lan:defaults.lan,
												isLogin: _isLogin,
												success: function(){
													if (defaults.success != null) {
														defaults.success(_isLogin);
													}
												}
											});
										}else{
											if (defaults.success != null) {
												defaults.success(_isLogin);
											}
										}
									}
								});
							}else{
								this.getToken({
									lan:defaults.lan,
									isLogin: _isLogin,
									success: function(){
										if (defaults.success != null) {
											defaults.success(_isLogin);
										}
									}
								});
							}

                        }else if(re['data']['is_login'] == 0){//未登录
                            if (defaults.success != null) {
                                defaults.success(_isLogin);
                            }
                        }
                    }
                }).catch((response)=>{
                console.log(response);
            });
        };

		/**
		 * 未登录跳转登录
		 * 已登录跳转个人中心
		 */
		Vue.prototype.gotoLogin = function(boo){
			var url = window.location.href,
				status = '';
			if(boo){
                status = 'true';
			}else{
				status = 'false';
			}
			window.location.href = '//accounts'+ this.getHostName() +'.'+ this.getLocal() +'.com/m/guess/index.html?ref=oversea_guess&islogin='+ status +'&url=' + encodeURIComponent(url);
		};

        /**
         * 读取用户信息
         * */
        Vue.prototype.getUserInfo = function(options){
            var defaults = {
                token: '',
                lan: this.langIndex,
                success: null
            };

            defaults = Object.assign(defaults, options);

            let _token = localStorage.getItem('guess_token');

            if(_token != null){
                defaults.token = _token;
            }else{
                return
            }

            this.axios.get(this.getHost() + '/users/info?lan='+defaults.lan + '&token=' + defaults.token).then(
                (response)=>{
                    if(defaults.success != null) {
                        defaults.success(response);
                    }
                }).catch((response)=>{
					if(defaults.success != null) {
						defaults.success(response);
					}
            });
        };

		/**
		 * 已登录跳转个人中心
		 */
		Vue.prototype.gotoPersonal = function(){
            var url = window.location.href;
            window.location.href = '//accounts'+ this.getHostName() +'.'+ this.getLocal() +'.com/m/guess/index.html?ref=oversea_guess&islogin=true&url=' + encodeURIComponent(url);
		};

        /**
		 * 获取token
		 */
        Vue.prototype.getToken = function(options){
			var defaults = {
				appId: 100002,
				source: null,
				platform: null,//平台(非必填 1 APP 2 webapp 3 PC)
				success: null,
				lan:null,
				isLogin: 0
			};

			defaults = Object.assign(defaults, options);

			this.delStorage('user_login_info');

			this.axios.defaults.withCredentials = true;
			this.axios.create({withCredentials: true}).post(this.getHost2() + '/user/passport/sync',qs.stringify({//获取登录凭证
					app_id: defaults.appId,
					source: defaults.source,
					platform: defaults.platform
				})
			).then(
				(response)=>{
				var re = response.data;
				//alert(JSON.stringify(re));
				if(re.code == 0){
					var sid = re.data.sid,
						st = re.data.st;

					this.axios.post(this.getHost() + '/users/login',qs.stringify({//获取token
							sid: sid,
							st: st,
							lan:this.langIndex,
							source: defaults.source,
							platform: defaults.platform,
							lan:defaults.lan
						})
					).then(
						(response)=>{
						var re = response.data;
					//alert(JSON.stringify(re));
					if(re.code == 200){
						this.infoStorage('guess_token', re.data.token);
						if (defaults.success != null) {
							defaults.success(defaults.isLogin);
						}
					}
				}).catch((response)=>{
						console.log(response);
				});
				}
			}).catch((response)=>{
					console.log(response);
			});
        };
	}
}


// WEBPACK FOOTER //
// ./src/lib/config.js